import Translate from "../../translate/Translate";
import { CustomDropdownBoxButton } from "../button/CustomDropdownBoxButton";

export default function ProvinceFilterButton({ currentValue, setValue }) {
    // TODO: 실제 통신을 통해서 받아올 것
    const values = [
        { label: Translate("store.allProvince"), value: "all" },
        { label: "Chomburi", value: "Chomburi" },
        { label: "Bangkok", value: "Bangkok" },
        { label: "Pathum Thani", value: "Pathum Thani" },
        { label: "Chiang Mai", value: "Chiang Mai" },
    ];

    return (
        <CustomDropdownBoxButton
            icon={currentValue === "all" ? "location_mark_black" : "location_mark_active"}
            currentValue={currentValue}
            setValue={setValue}
            values={values}
            useApplyButton
        />
    );
}
